/* SarhERP Project Copyright © 2021 SarhSoft All rights reserved M.Farhat */

export default {
      TeleClaimStatusRows: '$MHF_ModelNameVal_$MHF|TeleClaimStatusRows',

};
